/* eslint-disable react/prop-types */
import {
  Button,
  CircularProgress,
  FormControlLabel,
  Grid,
  useMediaQuery,
} from '@mui/material';
import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Sketch from '@uiw/react-color-sketch';
import {
  createTagDetails,
  editTagnames,
  getApiCall,
  getContactDetails,
  getTagDetails,
  getusertagDetails,
  storeTagnames,
} from 'api/apiService';
import Loading from 'assets/images/loading.png';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useEffect, useState } from 'react';
import TagPin from '../../assets/images/TagPin.png';
// import TablePagination from "@mui/material/TablePagination";
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Checkbox, Pagination, Stack, Switch } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { makeStyles, styled } from '@mui/styles';
import { visuallyHidden } from '@mui/utils';
import Avatar from 'antd/es/avatar/avatar';
import Dp from 'assets/dummy/buy.jpg';
import { fontsize10, poppins400 } from 'theme/common.style';
// import { makeStyles } from '@material-ui/core/styles';
import { HighlightOff } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import Popover from '@mui/material/Popover';
import CloseIcon from '@mui/icons-material/Close';
import {
  imageCont,
  userDetCont,
} from 'component/ActivityContainer/ActivityContainer.style';
import { BuyersCard } from 'component/BuyersCard/BuyersCard';
import { Feedback } from 'component/BuyersCard/Feedback';
import OwnerCard from 'component/OwnerCard/OwnerCard';
import { GET_BINDERID } from 'constant/app.config';
import Modal from 'react-modal';
import { useHistory } from 'react-router-dom';
import {
  ActionContainer,
  CategoryContainer,
  Contact,
  TagContainer,
} from './ContactTabItem.util';
import { checkbox_style } from './Table.style';
import { contactErrorContext } from './ContactTab';
import Moxochat from 'component/Moxochat/Moxochat';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { useTheme } from '@emotion/react';

export const IOSSwitch = styled((props) => {
  const [isOwner, setIsOwner] = useState(false);
  const toggle = () => {
    setIsOwner(true);
  };
  return (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
      onChange={toggle}
    />
  );
});

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const {
    order,
    orderBy,

    onRequestSort,
    headCells,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <TableHead>
      <TableRow>
        {/* {!matchessm && <TableCell padding="checkbox"></TableCell>} */}
        {headCells?.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            // align={headCell.numeric ? "right" : "left"}
            align="left"
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ ...poppins400, ...fontsize10, color: '#666666' }}
          >
            <TableSortLabel
              sx={{ marginLeft: index == 0 ? '63px' : '0px' }}
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  headCells: PropTypes.string.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {/* Nutrition */}
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export const CustomCheckbox = (props) => {
  const customCheckboxStyle = {
    background: 'rgba(196, 196, 196, 0.22)',
    // borderRadius: "1.6205px",
    height: '16.21px',
    width: '16.21px',
    border: 'none',
  };

  return <Checkbox {...props} sx={customCheckboxStyle} />;
};
export const collectId = (
  array,
  id,
  setBuyerId,
  setPosition,
  setArrayCollection
  // setUserType,
  // userType
) => {
  let arrayCollection = [];
  for (let index = 0; index < array.length; index++) {
    const element = array[index]?.user?.userId;
    arrayCollection.push(element);
  }
  setArrayCollection(arrayCollection);

  setBuyerId(id);
  let position = arrayCollection.indexOf(id);
  setPosition(position);
  // setUserType(userType);
};
const TagSvg = () => {
  return (
    <svg
      width="29"
      height="32"
      viewBox="0 0 29 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      href="http://www.w3.org/1999/xlink"
    >
      <rect width="29" height="32" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_24692_165597"
            transform="matrix(0.019025 0 0 0.0172414 -0.118312 0)"
          />
        </pattern>
        <image
          id="image0_24692_165597"
          width="65"
          height="58"
          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAA6CAYAAADvEjRHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAITcAACE3ATNYn3oAAAKYSURBVGhD7dlPSBRhGMfxx06tXVK7SAaJIRgU0sGDHQoLQqqLHTrkQWi9xOZp7ZZ07FC3oktCFy9BdAjqEtElIwOVggRBCDK6qN12vdXzG98Kh50/77x/Ziaf72Vnhp2F+Tjv7juvbb842uPtU697OkHgBIETBE4QOEHgBIETBE4QOEHgBIETBE4QOEHgBIETBC6XRZVGo0nvPy7R0qcv6kh8B9ordOnCCB3p6VZH7OYdAQD3H87St/Uf6ki6Bk8M0I3quNqzm9fhkBUA4VxXeUMwAXCdF4S0AD2Hu6mz46Da85dzhLQA9ZtVmrlVo7t3puncmWF11E9OEdIC9Pcdpf5jvWqP6OrYRbXlJ2cIRf4OCOcEQRdgde3rrjnD0+cv1ZafrM8TTO4ATIYajW3a3PqpjvwLQ6Y+Nan27Gb1TjAdAjivFYDrrCGU6TsgnBWEJADcyqY/e4Mnj6st+xkjJAEMD50KxjJ+9jAZyhLOw+e4ygghDcDEtSvBNt6z/l1/qACgXrtO7fwk6arMCLoAeK9uPgBQJoQsADhHJ18ASBvhfwNA2ghZAdI+HfoGQFoIr9++0waoVPbT7emdp0NcYFx5ACAthOWINUEsfUUB1GvVv2uDzeZ28NqqvACQFsKhrk61tbvzZ08Hr3EAT+aeRU6J8wRAWgiXR0eCiws3/2GRlj+vxALMLywG2+HyBkDaT5H4a9978Djy1i4bANL+dcDF4SJb3REIQ6NMAEgbAcVBYGqMRZJHs3OlAEBGiypJQ6NVRQNAme6EPyUNjXBFBEBGCCgtRFEBkDECSoIoMgCygoCiIIoOgKyvNmNW+OLVG9rY3AqWxPBMUWQA5P1f80XM2nAoc4LACQInCJwgcILACQInCET0G1Gbi9jasFZEAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  );
};

const SearchIconTag = () => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.04166 0C4.06043 0 0.833008 3.15614 0.833008 7.04945C0.833008 10.9427 4.06043 14.0989 8.04166 14.0989C9.74442 14.0989 11.3093 13.5216 12.5427 12.5561L14.8858 14.8415L14.9481 14.894C15.1657 15.0514 15.4741 15.0335 15.6709 14.8405C15.8874 14.6282 15.887 14.2845 15.6699 14.0727L13.3544 11.8142C14.5317 10.5595 15.2503 8.88655 15.2503 7.04945C15.2503 3.15614 12.0229 0 8.04166 0ZM8.04167 1.0858C11.4097 1.0858 14.14 3.75582 14.14 7.04945C14.14 10.3431 11.4097 13.0131 8.04167 13.0131C4.67365 13.0131 1.94333 10.3431 1.94333 7.04945C1.94333 3.75582 4.67365 1.0858 8.04167 1.0858Z"
        fill="#666666"
      />
    </svg>
  );
};
const ExpandIcon = () => {
  return (
    <svg
      width="30"
      height="27"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="1"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M17.8291 7.19042L23.3192 7.19042L23.3192 12.6949"
        stroke="#606060"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23 7.5L17.75 12.75"
        stroke="#606060"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M14.1748 21.8106L8.68467 21.8106L8.68467 16.3061"
        stroke="#606060"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.25 16.2559L9 21.5059"
        stroke="#606060"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default function EnhancedTable(props) {
  const {
    contextErrorMessage,
    setContextErrorMessage,
    setSelectedRows,
    selectedRows = [],
  } = props;
  const [changeToggle, setChangeToggle] = useState(false);
  const [expandFeedback, setExpandFeedback] = useState(false);
  const [selectedBuyerId, setSelectedBuyerId] = useState('');
  const [buyerId, setBuyerId] = React.useState('');
  const [userEmail, setUserEmail] = useState('');
  const [open, setOpen] = React.useState(false);
  const [selectedBuyers, setSelectedBuyers] = useState([]);
  const [LoaderUser, setLoaderUser] = useState(false);
  const [LoaderTag, setLoaderTag] = useState(false);
  const [userTagDetails, setUserTagDetails] = useState([]);
  const [tagArray, setTagArray] = useState([]);
  const [feedBackData, setFeedBackData] = useState(null);
  const [exportSelected, setExportSelected] = useState(selectedRows);
  const isUserAction = React.useRef(false);
  const isInitialRender = React.useRef(true);
  const { setIschatopen } = React.useContext(datacontext);
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const handleExportSelection = (buyerId, checked) => {
    let updated = [];

    if (checked) {
      updated = [...exportSelected, buyerId];
    } else {
      updated = exportSelected.filter((id) => id !== buyerId);
    }

    isUserAction.current = true;
    setExportSelected(updated);

    if (setSelectedRows) {
      setSelectedRows(updated);
    }

    setTimeout(() => {
      isUserAction.current = false;
    }, 200);
  };
  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    if (isUserAction.current) {
      return;
    }

    setExportSelected(selectedRows);
  }, [selectedRows]);

  let data = [];
  data = props?.properties?.userDetails
    ? props?.properties?.userDetails || []
    : props?.properties?.data || [];
  const user = props.user;
  const Apifunctions = async () => {
    setLoaderUser(true);
    setLoaderTag(true);
    let selecteddata = [];
    let alldata = [];
    await getusertagDetails(postTagId).then((res) => {
      if (res?.tagDetails?.length != 0) {
        selecteddata = res?.tagDetails;
        setUserTagDetails(res?.tagDetails);
        setLoaderUser(false);
      } else {
        setUserTagDetails(res?.tagDetails);
        setLoaderUser(false);
      }
    });
    await getTagDetails(postTagId).then((res) => {
      if (res?.status == 1) {
        setLoaderTag(false);
      } else {
        setLoaderTag(false);
      }
      alldata = res?.tagDetails;
      const results = alldata.filter(
        ({ tagName: id1 }) =>
          !selecteddata.some(({ tagName: id2 }) => id2 === id1)
      );
      setTagArray(results);
    });
  };
  const [showBackdrop, setShowBackDrop] = React.useState(false);
  const { headCells, setProperties } = props;
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const [totalPages, setTotalpages] = useState(1);
  const [row, setRow] = useState({});
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [isCardSelect, setIsCardSelect] = React.useState(false);
  const [openOwner, setOpenOwner] = React.useState(false);
  const [userType, setUserType] = React.useState('');
  const [openFeedback, setOpenFeedback] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(null);
  const [indexValue, setIndexValue] = useState(null);
  const [isHiddenRightArrow, setIsHiddenRightArrow] = useState(false);
  const [position, setPosition] = useState(0);
  const [arrayCollection, setArrayCollection] = useState([]);
  const [isChecked, setIsChecked] = React.useState(false);
  const [selectedUserType, setSelectedUserType] = useState([]);
  const [selectedIndexValue, setSelectedIndexValue] = useState([]);
  const [address, setAddress] = useState();
  const data1 = data?.userCount;

  const handlePageChange = (event, value) => {
    // setOffSet(page * 2);
    getContactDetails(value).then((resp) => {
      if (resp?.status == 1) {
        setPage(value);
        setProperties(resp);
        setIsModalOpen(() => resp?.userDetails?.map((i) => false));
      }
    });
  };

  const dataa = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(dataa);
  const dataType = userDetail?.userType;

  // const [errorMessage, setErrorMessage] = React.useState("");

  const getData = (page) => {
    var mounted = true;
    getContactDetails(page).then((resp) => {
      if (mounted) {
        if (resp.status === -1) {
          if (props.properties?.userDetails?.length > 0) {
            setContextErrorMessage('Owner/Buyer Not Available');
          } else {
            if (user == 'buyerAgent') {
              setContextErrorMessage('Agent not available');
            } else if (user == 'vendorAgent') {
              setContextErrorMessage('Agent not available');
            } else if (user == 'buyerSolicitor') {
              setContextErrorMessage('Solicitor not available');
            } else if (user == 'vendorSolicitor') {
              setContextErrorMessage('Solicitor not available');
            } else {
              setContextErrorMessage('No contacts available');
            }
          }
        } else {
          setIsModalOpen(() => resp?.userDetails?.map((i) => false));
          setProperties(resp);
          setTotalpages(resp?.userCount);
        }
      }
    });
    return () => (mounted = false);
  };

  useEffect(() => {
    getData(page);
  }, [page]);
  useEffect(() => {
    setArrayCollection(arrayCollection);
  }, [arrayCollection]);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = data.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };
  const handleClick = async (
    isChecked,
    index,
    buyerId,
    userCategory = [],
    row,
    isCardSelected
  ) => {
    setIsHiddenRightArrow(true);
    setIndexValue(index);
    if (isChecked) {
      setShowBackDrop(true);
    }
    setRow(row);
    setBuyerId(buyerId);
    const selectedIndex = selected.indexOf(index);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    let userType = '';
    if (userCategory.length > 1) {
      userType = 'Both';
    } else if (userCategory.filter((e) => e.userType === 'Buyer').length > 0) {
      userType = 'Buyer';
    } else {
      userType = 'Owner';
    }

    setSelected(newSelected);
    setUserType(userType);

    const UserTypeObj = {
      id: buyerId,
      userType: userType,
    };
    await setSelectedUserType([UserTypeObj, ...selectedUserType]);

    if (userType === 'Buyer') {
      setOpenOwner(false);
      if (isChecked) {
        setSelectedBuyers(
          (prevSelected) => [...prevSelected, buyerId],
          setOpen(isChecked),
          setOpenOwner(false),
          setIsChecked(true)
        );

        setSelectedIndexValue((prevSelected) => [...prevSelected, indexValue]);
      } else if (!isChecked) {
        setOpen(false);

        setSelectedBuyers((prevSelected) =>
          prevSelected.filter((id) => id !== buyerId)
        );
        const filtered = selectedUserType.filter((obj) => obj.id !== buyerId);
        setSelectedUserType(filtered);
      }
    } else if (userType === 'Owner' || userType === 'Both') {
      if (isChecked) {
        setSelectedBuyers(
          (prevSelected) => [...prevSelected, buyerId],
          setOpenOwner(true),
          setIsCardSelect(true)
        );

        setSelectedIndexValue((prevSelected) => [...prevSelected, indexValue]);
        // setOpenOwner(isCardSelected);
      } else if (!isChecked) {
        setOpenOwner(false);

        setSelectedBuyers((prevSelected) =>
          prevSelected.filter((id) => id !== buyerId)
        );
        const filtered = selectedUserType.filter((obj) => obj.id !== buyerId);
        setSelectedUserType(filtered);
      }
    }
  };
  const handleClickUserName = async (
    isChecked,
    index,
    buyerId,
    userCategory = [],
    row,
    isCardSelected
  ) => {
    const isAgent = userCategory.some((e) => e.userType === 'Agent');
    if (isAgent) {
      return;
    }
    setIsHiddenRightArrow(!isHiddenRightArrow);
    setIndexValue(index);
    setRow(row);
    setBuyerId(buyerId);
    const selectedIndex = selected.indexOf(index);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    let userType = '';
    if (userCategory.length > 1) {
      userType = 'Both';
    } else if (userCategory.filter((e) => e.userType === 'Buyer').length > 0) {
      userType = 'Buyer';
    } else {
      userType = 'Owner';
    }

    setSelected(newSelected);
    setUserType(userType);

    const UserTypeObj = {
      id: buyerId,
      userType: userType,
    };
    // await setSelectedUserType([UserTypeObj, ...selectedUserType]);

    if (userType === 'Buyer') {
      setOpen(true);
      setOpenOwner(false);
      if (showBackdrop) {
        setOpen(isChecked);
        setIsChecked(true);
        // setIsChecked((prevChecked) => !prevChecked);
      }
    } else if (userType === 'Owner' || userType === 'Both') {
      setOpenOwner(true);
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data?.length) : 0;

  // const totalPages = Math.ceil(data1 /data);
  const useStyles = makeStyles((theme) => ({
    root: {
      '& .MuiPaginationItem-root': {
        // styles for each pagination item
        color: '#9C9C9C',
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '400px',
        margin: -3,
        padding: -3,
        // gap:9
      },
      '& .MuiPaginationItem-root.Mui-selected': {
        // styles for the currently selected pagination item
        backgroundColor: 'white',
        color: '#6C2AD2',
      },

      '& .MuiPaginationItem-icon': {
        color: 'rgba(20, 20, 43, 1)', // Customize the arrow color here
      },
    },
  }));
  const PGcolor = useStyles();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [postTagId, setPostTagId] = useState('');
  const [userName, setUserName] = useState('');
  const [userInitial, setUserInitial] = useState('');
  const [userSurName, setUserSurName] = useState('');

  const handleIconClick = (id, event, name, userSurName) => {
    setUserName(name);
    setUserSurName(userSurName);
    setPostTagId(id);
    if (anchorEl == null) {
      setAnchorEl(event.currentTarget);
    } else {
      setAnchorEl(null);
    }
  };
  const openPop = Boolean(anchorEl);
  const idPop = open ? 'simple-popover' : undefined;

  const history = useHistory();

  const onShowChat = (binderId) => {
    setIschatopen(binderId);
    setModalIsOpen(true);
  };

  const directcomm = (userId, userType) => {
    const data = localStorage.getItem('userDetail');
    const userDetail = JSON.parse(data);
    const agentId = userDetail?.userId;

    if (userId) {
      const isVendorOrBuyer =
        userDetail?.primaryUserType === 'Vendor' ||
        userDetail?.primaryUserType === 'Buyer';

      const firstId = isVendorOrBuyer ? userId : agentId;
      const secondId = isVendorOrBuyer ? agentId : userId;

      getApiCall(
        GET_BINDERID + `/${firstId}` + `/${secondId}` + `/0` + `/${userType}`
      ).then((resp) => {
        onShowChat(resp?.data?.binderId);
      });
    }
  };

  const token = localStorage.getItem('moxoDetail');
  const bearerToken = JSON.parse(token);
  const [timer, setTimer] = useState(true);
  // useEffect(() => {
  //   window.mepsdk.setup({
  //     baseDomain: 'https://stratsmart-demo.moxtra.com',
  //     deployDirectory: 'web',
  //     accessToken: bearerToken,
  //   });
  //   setTimeout(() => {
  //     setTimer(false);
  //   }, 2500);
  //   window.mepsdk.setConfig({});
  // }, []);

  const toTitleCase = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  return (
    <>
      <Grid style={{ padding: '0px !important' }}>
        {selectedBuyers?.length > 0 &&
        //  && selectedUserType?.length > 0
        userType === 'Owner' &&
        showBackdrop ? (
          selectedBuyers?.map((value, index, openOwner, userTypeObj) => {
            return (
              <OwnerCard
                // selectedBuyers={value}
                changeToggle={changeToggle}
                setChangeToggle={setChangeToggle}
                isCardSelect={isCardSelect}
                selectedBuyers={selectedBuyers}
                setSelectedBuyers={setSelectedBuyers}
                selectedBuyerId={selectedBuyerId}
                setSelectedBuyerId={setSelectedBuyerId}
                openOwner={openOwner}
                setOpenOwner={setOpenOwner}
                isChecked={isChecked}
                setIsChecked={setIsChecked}
                arrayCollection={arrayCollection}
                setPosition={setPosition}
                setBuyerId={setBuyerId}
                setArrayCollection={setArrayCollection}
                showBackdrop={showBackdrop}
                setShowBackDrop={setShowBackDrop}
                open={openOwner}
                setOpen={setOpenOwner}
                buyerId={value}
                setOpenBuyer={setOpen}
                openBuyer={open}
                userType={userType}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                index={indexValue}
                isHiddenRightArrow={isHiddenRightArrow}
                setIsHiddenRightArrow={setIsHiddenRightArrow}
                data={data}
                position={position}
                setUserType={setUserType}
                count={index}
                rowData={row}
                onShowChat={onShowChat}
              />
            );
          })
        ) : (
          <OwnerCard
            // selectedBuyers={value}
            selectedBuyerId={selectedBuyerId}
            setSelectedBuyerId={setSelectedBuyerId}
            openOwner={openOwner}
            setOpenOwner={setOpenOwner}
            isChecked={isChecked}
            setIsChecked={setIsChecked}
            arrayCollection={arrayCollection}
            setPosition={setPosition}
            setBuyerId={setBuyerId}
            setArrayCollection={setArrayCollection}
            showBackdrop={showBackdrop}
            setShowBackDrop={setShowBackDrop}
            open={openOwner}
            setOpen={setOpenOwner}
            buyerId={buyerId}
            setOpenBuyer={setOpen}
            openBuyer={open}
            userType={userType}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            index={indexValue}
            isHiddenRightArrow={isHiddenRightArrow}
            setIsHiddenRightArrow={setIsHiddenRightArrow}
            data={data}
            position={position}
            setUserType={setUserType}
            rowData={row}
            onShowChat={onShowChat}
          />
        )}
        {data?.length > 0 ? (
          <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none' }}>
            {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
            <TableContainer
              style={{ border: '1px solid #D9D9D9', borderRadius: '5px' }}
            >
              <Table
                // sx={{ minWidth: 750 }}
                aria-labelledby="tableTitle"
                size="medium"
              >
                <EnhancedTableHead
                  headCells={headCells}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {/* if you don't need to support IE11, you can replace the `stableSort` call with:
             rows.sort(getComparator(order, orderBy)).slice() */}
                  {/* {stableSort(tableData, getComparator(order, orderBy)) */}
                  {/* .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) */}
                  {Array.isArray(data) ? (
                    data?.map((row, index) => {
                      // let isModalOpen = row.isModalOpen === "true";
                      const buyerId = row?.user?.userId;

                      const userCategory = row?.userCategory;
                      const isCardSelected = selectedBuyers?.includes(buyerId);
                      const userName = row?.userName;
                      const isItemSelected = isSelected(index);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.name}
                          // selected={isItemSelected}
                        >
                          {/* {!matchessm && (
                            <TableCell>
                              <Typography
                                style={{
                                  paddingLeft: '16.88px',
                                  marginRight: '-20px',
                                }}
                              >
                                <FormControlLabel
                                  key={index + buyerId}
                                  // key={buyerId}
                                  className="checkbox"
                                  control={
                                    <input
                                      name={userName}
                                      value={buyerId}
                                      id={row?.userMobile}
                                      checked={exportSelected.includes(buyerId)}
                                      color="primary"
                                      onChange={(event) => {
                                        event.stopPropagation();

                                        const checked = event.target.checked;

                                        if (checked) {
                                          setSelectedRows((prev) => [
                                            ...prev,
                                            buyerId,
                                          ]);
                                        } else {
                                          setSelectedRows((prev) =>
                                            prev.filter((id) => id !== buyerId)
                                          );
                                        }

                                        handleExportSelection(buyerId, checked);
                                      }}
                                      type="checkbox"
                                    />
                                  }
                                />
                              </Typography>
                              <Typography sx={checkbox_style} />
                            </TableCell>
                          )} */}

                          <TableCell
                            component="th"
                            id={labelId}
                            scope="row"
                            padding="none"
                          >
                            <Grid
                              container
                              sx={{ justifyContent: 'space-between' }}
                            >
                              <Typography sx={userDetCont}>
                                <Typography sx={imageCont}>
                                  {row?.user?.userProfile == '' ||
                                  row?.user?.userProfile == null ? (
                                    <Avatar
                                      style={{
                                        width: '29px',
                                        height: '29px',
                                        backgroundColor: '#666666',
                                        fontFamily: 'poppins',
                                        fontSize: '12px',
                                      }}
                                      onClick={(event) => {
                                        if (dataType[0].userType == 'Agent') {
                                          handleClick(
                                            event.target.checked,
                                            index,
                                            buyerId,
                                            userCategory,
                                            row
                                          );

                                          collectId(
                                            data,
                                            buyerId,
                                            setBuyerId,
                                            setPosition,
                                            setArrayCollection
                                            // setUserType,
                                            // userType
                                          );
                                        }
                                      }}
                                    >
                                      {row?.user?.userName
                                        ?.charAt(0)
                                        ?.toUpperCase() +
                                        row?.user?.userSurName
                                          ?.charAt(0)
                                          ?.toUpperCase()}
                                    </Avatar>
                                  ) : (
                                    <Avatar
                                      alt="Remy"
                                      src={row?.user?.userProfile}
                                      onClick={(event) => {
                                        if (dataType[0].userType == 'Agent') {
                                          handleClick(
                                            event.target.checked,
                                            index,
                                            buyerId,
                                            userCategory,
                                            row
                                          );

                                          collectId(
                                            data,
                                            buyerId,
                                            setBuyerId,
                                            setPosition,
                                            setArrayCollection
                                            // setUserType,
                                            // userType
                                          );
                                        }
                                      }}
                                    />
                                  )}
                                  &nbsp;&nbsp;
                                  <Typography
                                    sx={{
                                      fontSize: '12px',
                                      fontFamily: 'Poppins',
                                      fontWeight: '400',
                                      cursor: 'pointer',
                                    }}
                                    onClick={(event) => {
                                      if (dataType[0].userType == 'Agent') {
                                        handleClickUserName(
                                          event.target.checked,
                                          index,
                                          buyerId,
                                          userCategory,
                                          row
                                        );

                                        collectId(
                                          data,
                                          buyerId,
                                          setBuyerId,
                                          setPosition,
                                          setArrayCollection
                                          // setUserType,
                                          // userType
                                        );
                                      }
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: '12px',
                                        fontFamily: 'Poppins',
                                        fontWeight: '400',
                                        cursor: 'pointer',
                                        whiteSpace: 'nowrap',
                                        color: '#112347',
                                      }}
                                      onClick={(event) => {
                                        if (dataType[0].userType == 'Agent') {
                                          handleClickUserName(
                                            event.target.checked,
                                            index,
                                            buyerId,
                                            userCategory,
                                            row,
                                            setShowBackDrop(false)
                                          );

                                          collectId(
                                            data,
                                            buyerId,
                                            setBuyerId,
                                            setPosition,
                                            setArrayCollection
                                          );
                                        }
                                      }}
                                    >
                                      {row?.user
                                        ? `${toTitleCase(
                                            row?.user?.userName
                                          )} ${toTitleCase(
                                            row?.user?.userSurName
                                          )}`
                                        : `${toTitleCase(
                                            row?.userName
                                          )} ${toTitleCase(row?.userSurName)}`}
                                    </Typography>
                                  </Typography>
                                </Typography>
                              </Typography>
                            </Grid>
                          </TableCell>

                          <TableCell align="left">
                            {!row?.user && (
                              <Button
                                variant="outlined"
                                sx={{
                                  fontSize: '12px',
                                  fontFamily: 'Poppins',
                                  fontWeight: '400',
                                  width: '96px',
                                  height: '30px',
                                  mr: 1,
                                  color: '#6C2AD2',
                                  border: '1px solid #6C2AD2',
                                  padding: '6px 14px 6px 14px',
                                  textTransform: 'none',
                                }}
                              >
                                #{row?.userType}
                              </Button>
                            )}
                            {<CategoryContainer data={row} />}
                          </TableCell>
                          <TableCell align="left">
                            <Box
                              sx={{ display: 'flex', justifyContent: 'left' }}
                            >
                              {
                                <Contact
                                  row={row}
                                  directcomm={directcomm}
                                  index={null}
                                />
                              }
                            </Box>
                          </TableCell>
                          <TableCell align="left">
                            {
                              <TagContainer
                                anchorEl={anchorEl}
                                setAnchorEl={setAnchorEl}
                                idPop={idPop}
                                handleIconClick={handleIconClick}
                                row={row}
                                tagArray={tagArray}
                              />
                            }
                          </TableCell>
                          <TableCell align="left">
                            {
                              <ActionContainer
                                rowData={row}
                                setFeedBackData={setFeedBackData}
                                feedBackData={feedBackData}
                                marginLeft={true}
                                openFeedback={openFeedback}
                                setOpenFeedback={setOpenFeedback}
                                userName={userName}
                                setUserType={setUserType}
                                setUserName={setUserName}
                                setBuyerId={setBuyerId}
                                setUserEmail={setUserEmail}
                                setUserInitial={setUserInitial}
                                dataType={dataType}
                              />
                            }
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} />
                      {contextErrorMessage && (
                        <div>
                          <Typography
                            sx={{
                              fontFamily: 'Poppins',
                              fontSize: '10px',
                              color: '#666666',
                              paddingLeft: '100px',
                            }}
                          >
                            {contextErrorMessage}
                          </Typography>
                        </div>
                      )}
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        ) : (
          <Box>
            <Typography
              sx={{
                fontFamily: 'Poppins',
                fontSize: '14px',
                fontWeight: 500,
                color: '#666666',
                paddingLeft: '0px',
                display: 'flex',
                justifyContent: 'center',
                marginTop: '10px',
              }}
            >
              {data?.length == 0 && !timer ? contextErrorMessage : ''}
            </Typography>
          </Box>
        )}
      </Grid>
      {/* {isModalOpen && ( */}

      {selectedBuyers.length > 0 && showBackdrop && userType === 'Buyer'
        ? selectedBuyers?.map((value, index, open, userTypeObj) => {
            return (
              !expandFeedback && (
                <BuyersCard
                  isCardSelect={isCardSelect}
                  selectedBuyers={selectedBuyers}
                  isChecked={isChecked}
                  changeToggle={changeToggle}
                  setChangeToggle={setChangeToggle}
                  setSelectedBuyerId={setSelectedBuyerId}
                  setSelectedBuyers={setSelectedBuyers}
                  selectedBuyerId={selectedBuyerId}
                  showBackdrop={showBackdrop}
                  setShowBackDrop={setShowBackDrop}
                  buyersId={buyerId}
                  openOwner={openOwner}
                  setOpenOwner={setOpenOwner}
                  open={open}
                  setOpen={setOpen}
                  userType={userType}
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  expandFeedback={expandFeedback}
                  setExpandFeedback={setExpandFeedback}
                  index={indexValue}
                  isHiddenRightArrow={isHiddenRightArrow}
                  setIsHiddenRightArrow={setIsHiddenRightArrow}
                  position={position}
                  arrayCollection={arrayCollection}
                  data={data}
                  buyerId={value}
                  setBuyerId={setBuyerId}
                  setPosition={setPosition}
                  setArrayCollection={setArrayCollection}
                  setUserType={setUserType}
                  count={index}
                  rowData={row}
                  onShowChat={onShowChat}
                />
              )
            );
          })
        : !expandFeedback && (
            <BuyersCard
              changeToggle={changeToggle}
              setChangeToggle={setChangeToggle}
              setSelectedBuyerId={setSelectedBuyerId}
              setSelectedBuyers={setSelectedBuyers}
              selectedBuyerId={selectedBuyerId}
              showBackdrop={showBackdrop}
              setShowBackDrop={setShowBackDrop}
              buyersId={buyerId}
              openOwner={openOwner}
              setOpenOwner={setOpenOwner}
              open={open}
              setOpen={setOpen}
              userType={userType}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              expandFeedback={expandFeedback}
              setExpandFeedback={setExpandFeedback}
              index={indexValue}
              isHiddenRightArrow={isHiddenRightArrow}
              setIsHiddenRightArrow={setIsHiddenRightArrow}
              position={position}
              arrayCollection={arrayCollection}
              data={data}
              buyerId={buyerId}
              setBuyerId={setBuyerId}
              setPosition={setPosition}
              setArrayCollection={setArrayCollection}
              setUserType={setUserType}
              rowData={row}
              onShowChat={onShowChat}
            />
          )}
      {(openFeedback || expandFeedback) && (
        <Feedback
          buyerId={buyerId}
          expandFeedback={expandFeedback}
          setExpandFeedback={setExpandFeedback}
          openFeedback={openFeedback}
          setOpenFeedback={setOpenFeedback}
          setUserName={setUserName}
          userName={userName}
          data={feedBackData}
          userType={userType}
          ownercardprop={userType == 'Vendor' ? true : false}
          marketShow={false}
          proid={0}
          userEmail={userEmail}
          address={address}
          setAddress={setAddress}
          directcomm={directcomm}
          index={null}
          row={feedBackData}
          buyerCardOpen={userType === 'Buyer' ? open : openOwner}
          setBuyerCardOpen={userType === 'Buyer' ? setOpen : setOpenOwner}
          userInitial={userInitial}
          // proUniqueId={proUniqueId}
          // buyerpropertylist={buyerpropertylist}
        />
      )}
      {totalPages > 10 && (
        <Stack sx={{ float: 'right' }} style={{ color: '#6C2AD2' }}>
          <Pagination
            className={PGcolor.root}
            sx={{ marginBottom: matchessm ? '80px' : '10px' }}
            count={Math.ceil(totalPages / 10)}
            // defaultPage={page}
            page={page}
            onChange={handlePageChange}
          />
        </Stack>
      )}
      <Popover
        sx={{
          boxShadow: 'none',
          padding: 0,
          maxWidth: '600px',
        }}
        open={openPop}
        anchorEl={anchorEl}
        onClose={handleIconClick}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <TagPopOver
          postTagId={postTagId}
          setLoaderUser={setLoaderUser}
          LoaderTag={LoaderTag}
          setLoaderTag={setLoaderTag}
          userTagDetails={userTagDetails}
          setUserTagDetails={setUserTagDetails}
          tagArray={tagArray}
          setTagArray={setTagArray}
          Apifunctions={Apifunctions}
          LoaderUser={LoaderUser}
          userName={userName}
          userSurName={userSurName}
          handleIconClick={handleIconClick}
        />
      </Popover>
      {modalIsOpen && <Moxochat open={modalIsOpen} onClose={setModalIsOpen} />}
    </>
  );
}

const BackIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_24781_168448)">
        <path
          d="M20 11.5H7.83L13.42 5.91L12 4.5L4 12.5L12 20.5L13.41 19.09L7.83 13.5H20V11.5Z"
          fill="#666666"
        />
      </g>
      <defs>
        <clipPath id="clip0_24781_168448">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const Multi = () => {
  return (
    <svg
      width="42"
      height="40"
      viewBox="0 0 42 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      href="http://www.w3.org/1999/xlink"
    >
      <rect y="-2" width="42" height="42" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        />
        <use href="#image0_24781_168443" transform="scale(0.0263158)" />
      </defs>
      <image
        id="image0_24781_168443"
        width="38"
        height="38"
        href="data:image/png;base64,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"
      />
    </svg>
  );
};

const Tick = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 6L6 11L16 1"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const TagPopOver = ({
  postTagId,
  setLoaderUser,
  LoaderTag,
  setLoaderTag,
  userTagDetails,
  setUserTagDetails,
  tagArray,
  setTagArray,
  Apifunctions,
  LoaderUser,
  handleIconClick,
  userName,
  userSurName,
}) => {
  const [editTags, setEditTags] = useState(false);
  const [tags, setTags] = useState(false);
  const [addTags, setAddTags] = useState(false);
  const [wheelFlag, setWheelFlag] = useState(false);
  const [hex, setHex] = useState('brown');
  const [apiTags, setApiTags] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [tagsValue, setTagsValue] = useState('');
  const [colorIndex, setColorIndex] = useState(null);
  const [editTagState, setEditTagState] = useState(false);
  const [tagId, setTagId] = useState();
  const [storeTag, setStoreTag] = useState('');
  const [initialUserTags, setInitialUserTags] = useState(null);
  const [originalEditTag, setOriginalEditTag] = useState(null);
  const [editTagVal, setEditTagVal] = useState('');
  const [colorCode, setColorCode] = useState([
    '#FFCCFF',
    '#FF9999',
    '#FFFF99',
    '#9999FF',
    '#FF62B2',
    '#66FFFF',
    '#66FF66',
    '#FFb266',
  ]);

  const handleClose = () => {
    cancelFunc();
    setInitialUserTags(null);
    setUserTagDetails([]);
    setTagArray([]);
    handleIconClick();
  };

  useEffect(() => {
    if (LoaderUser) {
      setInitialUserTags(null);
    } else if (userTagDetails && initialUserTags === null) {
      setInitialUserTags(userTagDetails);
    }
  }, [LoaderUser, userTagDetails, initialUserTags]);

  useEffect(() => {
    setTimeout(() => {
      setStoreTag('');
    }, 3000);
  }, [storeTag]);
  useEffect(() => {
    if (editTagVal != '') {
      setTimeout(() => {
        setEditTagVal('');
        setEditTags(true);
        setAddTags(false);
      }, 1500);
    }
  }, [editTagVal]);

  const cancelFunc = () => {
    setAddTagsArr([]);
    setColorIndex(null);
    setOriginalEditTag(null);
    setEditTagState(false);
    if (addTags) {
      setEditTags(false);
      setAddTags(false);
    } else if (editTags) {
      setEditTags(false);
      setAddTags(false);
    }
  };

  const [addTagsArr, setAddTagsArr] = useState([]);
  useEffect(() => {
    Apifunctions();
  }, []);
  const handleTagSelect = (tagCode, tagName, tagColor) => {
    const input = {
      tagName: tagName,
      tagCode: tagCode,
      tagColor: tagColor,
    };
    const newUserTagArr = [...userTagDetails, input];
    setUserTagDetails(newUserTagArr);
    let selectedTag = tagArray?.filter((item) => item.tagName != tagName);
    setTagArray([...selectedTag]);
    let selectedApiArr = newUserTagArr?.map((item) => item.tagCode);
    setApiTags([...selectedApiArr]);
  };

  const handleRemove = (tagName, tagCode, tagColor) => {
    const input = {
      tagName: tagName,
      tagCode: tagCode,
      tagColor: tagColor,
    };
    const newTagArr = [...tagArray, input];
    setTagArray(newTagArr);
    let newTagArr1 = userTagDetails?.filter((item) => item.tagCode != tagCode);
    setUserTagDetails(newTagArr1);
    const code = newTagArr1?.map((item) => item?.tagCode);
    setApiTags([...code]);
  };

  const handleClickPost = () => {
    if (addTags && editTags && !editTagState) {
      const input = {
        tagDetails: addTagsArr,
      };
      if (addTagsArr?.length != 0) {
        storeTagnames(input)
          .then((res) => {
            setIsLoader(true);
            if (res?.status == 1) {
              setTagsValue('');
              setHex('');
              setColorIndex();
              Apifunctions();
              setIsLoader(false);
              setAddTagsArr([]);
              setAddTags(false);
              setEditTags(false);
            } else {
              setStoreTag(
                res?.message == 'Tag Name Already Exist !'
                  ? 'Tag Name Already Exist !'
                  : 'Tag Color Already Exist !'
              );
              Apifunctions();
              setIsLoader(false);
            }
          })
          .catch(() => setIsLoader(false));
      }
    } else if (!addTags && !editTags) {
      const apiCont = userTagDetails?.map((item) => item.tagCode);
      const input = {
        userId: postTagId,
        tagCode: apiCont,
      };
      createTagDetails(input).then((res) => {
        setIsLoader(true);
        if (res?.status == 1) {
          getusertagDetails(postTagId).then((res) => {
            setUserTagDetails(res?.tagDetails);
            if (res?.tagDetails?.length == 0) {
              setTags(true);
            } else {
              setTags(false);
            }
            Apifunctions();
          });
          setIsLoader(false);
        } else {
          setIsLoader(false);
        }
        handleIconClick();
      });
    } else if (editTagState) {
      const input = {
        tagId: tagId,
        tagName: tagsValue,
        tagColor: hex,
      };
      editTagnames(input).then((res) => {
        setIsLoader(true);
        if (res?.status == 1) {
          Apifunctions();
          setAddTagsArr([]);
          setTagsValue('');
          setTagId();
          setColorIndex();
          setEditTagState(false);
          setOriginalEditTag(null);
          setAddTags(false);
          setEditTags(false);
          setIsLoader(false);
        } else {
          setEditTagState(false);
          setOriginalEditTag(null);
          setIsLoader(false);
          Apifunctions();
          setEditTagVal(res?.message);
        }
      });
    }
  };

  useEffect(() => {
    if (!editTags || !addTags) {
      setTagsValue('');
    }
  }, [editTags, addTags]);

  const colorSelect = (code, index) => {
    setHex(code);
    setColorIndex(index);
  };

  const addNewTags = () => {
    if (!editTagState) {
      if (tagsValue != '' && hex != '') {
        const input = {
          tagName: tagsValue,
          tagColor: hex,
        };
        setAddTagsArr([...addTagsArr, input]);
        setTagsValue('');
        // setHex("");
        setColorIndex(null);
      }
    }
  };

  const handleEditTag = (item) => {
    setEditTagState(true);
    setAddTags(true);
    setEditTags(true);
    setTagsValue(item.tagName);
    setTagId(item.tagId);
    setHex(item.tagColor);
    setOriginalEditTag(item);
  };

  const isSaveEnabled = () => {
    if (isLoader) return false;

    // Case 1: Assigning tags to the contact
    if (!addTags && !editTags) {
      if (!initialUserTags || !userTagDetails) return false;
      if (initialUserTags.length !== userTagDetails.length) return true;
      const initialCodes = initialUserTags.map((item) => item.tagCode).sort();
      const currentCodes = userTagDetails.map((item) => item.tagCode).sort();
      return !initialCodes.every((val, index) => val === currentCodes[index]);
    }

    // Case 2: Editing an existing tag definition
    if (editTagState) {
      return (
        originalEditTag &&
        tagsValue.trim() !== '' &&
        (tagsValue !== originalEditTag.tagName ||
          hex !== originalEditTag.tagColor)
      );
    }

    // Case 3: Adding/creating a new tag definition
    if (addTags && editTags) {
      return addTagsArr.length > 0;
    }

    return false;
  };

  const removeTag = (tagName) => {
    const newAddArr = addTagsArr?.filter((item) => item.tagName != tagName);
    setAddTagsArr(newAddArr);
  };
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Grid
      container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        padding: '10px 25px 0 25px',
        boxShadow: 'none',
      }}
    >
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img src={TagPin} alt="TagPin" height={'30px'} width={'30px'}></img>
          <Typography
            sx={{
              marginLeft: '10px',
              fontWeight: 500,
              fontFamily: 'poppins',
              color: '#666',
              fontSize: '14px',
            }}
          >
            Add or edit tags - {userName} {userSurName}
          </Typography>
        </Box>
        <IconButton onClick={handleClose} size="small" sx={{ color: '#666' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          border: '1px solid lightblue',
          padding: '5px',
        }}
      >
        <SearchIconTag />
        <input
          style={{
            width: '100%',
            fontFamily: 'poppins',
            border: 'none',
            fontSize: '14px',
          }}
          value={tagsValue}
          onChange={(e) => setTagsValue(e.target.value)}
          placeholder="Search for Tags"
        />
      </Grid>
      {!editTags && (
        <Grid container sx={{ height: '250px', overflowX: 'auto' }}>
          <Grid
            item
            xs={12}
            sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
          >
            <Typography
              sx={{ color: 'grey', fontFamily: 'poppins', fontStyle: 'italic' }}
            >
              Selected
            </Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                flexWrap: 'wrap',
              }}
            >
              {userTagDetails?.length != 0
                ? userTagDetails?.map((item) => (
                    <Button
                      color="error"
                      variant="outlined"
                      sx={{
                        position: 'relative',
                        borderRadius: '20px',
                        padding: '8px 20px',
                        color: '#F93939',
                        fontSize: '12px',
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        textTransform: 'none',
                        border: 'none !important',
                        backgroundColor: item.tagColor
                          ? item.tagColor
                          : 'lightblue',
                        textTransform: 'capitalize',
                        color: item.tagColor ? 'white' : 'grey',
                        '&:hover': {
                          backgroundColor: item.tagColor
                            ? item.tagColor
                            : 'lightblue',
                        },
                      }}
                    >
                      <HighlightOff
                        onClick={() =>
                          handleRemove(
                            item?.tagName,
                            item?.tagCode,
                            item?.tagColor
                          )
                        }
                        sx={{
                          position: 'absolute',
                          zIndex: 9999,
                          right: '-5px',
                          top: '-5px',
                          backgroundColor: '#ffff',
                          borderRadius: '50%',
                          color: 'grey',
                        }}
                      />
                      {item.tagName}
                    </Button>
                  ))
                : apiTags?.length == 0 &&
                  !LoaderUser && (
                    <Typography
                      sx={{
                        fontFamily: 'poppins',
                        fontWeight: 400,
                        color: 'grey',
                        fontStyle: 'italic',
                      }}
                    >
                      No tags selected
                    </Typography>
                  )}
              {LoaderUser && (
                <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
                  <img
                    alt="Logo"
                    src={Loading}
                    className="loaderImage"
                    style={{ height: '75px', width: '75px' }}
                  />
                </Grid>
              )}
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              marginTop: '40px',
              width: '450px',
            }}
          >
            <Typography
              sx={{ color: 'grey', fontFamily: 'poppins', fontStyle: 'italic' }}
            >
              Not Selected
            </Typography>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                flexWrap: 'wrap',
              }}
            >
              {Array.isArray(tagArray) &&
                tagArray?.map((item) => (
                  <Button
                    // color="error"
                    variant="outlined"
                    onClick={() =>
                      handleTagSelect(
                        item?.tagCode,
                        item?.tagName,
                        item?.tagColor
                      )
                    }
                    sx={{
                      borderRadius: '20px',
                      padding: '8px 20px',
                      color: '#F93939',
                      fontSize: '12px',
                      fontFamily: 'Poppins',
                      fontWeight: '400',
                      textTransform: 'none',
                      border: 'none !important',
                      backgroundColor: item.tagColor
                        ? item.tagColor
                        : 'lightblue',
                      textTransform: 'capitalize',
                      color: item.tagColor ? 'white' : 'grey',
                      '&:hover': {
                        backgroundColor: item.tagColor
                          ? item.tagColor
                          : 'lightblue',
                      },
                    }}
                  >
                    {item?.tagName}
                  </Button>
                ))}
              {LoaderTag && (
                <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
                  <img
                    alt="Logo"
                    src={Loading}
                    className="loaderImage"
                    style={{ height: '75px', width: '75px' }}
                  />
                </Grid>
              )}
              <Button
                onClick={() => {
                  setAddTags(true);
                  setEditTags(true);
                }}
                color="primary"
                sx={{
                  width: '80px',
                  padding: 0,
                  color: '#4CA4D6',
                  fontSize: '14px',
                  fontFamily: 'Poppins',
                  fontWeight: '400',
                  textTransform: 'none',
                  border: 'none !important',
                  whiteSpace: 'nowrap',
                  margin: '0 10px',
                }}
              >
                + Add Tags
              </Button>
            </Box>
          </Grid>
        </Grid>
      )}
      {editTags && !addTags && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            margin: '20px 0',
            height: '165px',
            overflowY: 'auto',
          }}
        >
          {tagArray?.length != 0 ? (
            tagArray?.map((item) => (
              <Button
                // color="error"
                variant="outlined"
                onClick={() => handleEditTag(item)}
                sx={{
                  maxWidth: 'min-content',
                  whiteSpace: 'nowrap',
                  borderRadius: '20px',
                  padding: '8px 20px',
                  color: '#F93939',
                  fontSize: '12px',
                  fontFamily: 'Poppins',
                  fontWeight: '400',
                  textTransform: 'none',
                  border: 'none !important',
                  backgroundColor: item.tagColor ? item.tagColor : 'lightblue',
                  textTransform: 'capitalize',
                  color: item.tagColor ? 'white' : 'grey',
                  '&:hover': {
                    backgroundColor: item.tagColor
                      ? item.tagColor
                      : 'lightblue',
                  },
                }}
              >
                {item?.tagName}
              </Button>
            ))
          ) : (
            <Typography
              sx={{
                fontFamily: 'poppins',
                fontWeight: 400,
                color: 'grey',
                fontStyle: 'italic',
              }}
            >
              No Tags Available
            </Typography>
          )}
        </Box>
      )}

      {addTags && editTags && (
        <>
          <Typography sx={{ fontSize: '14px', fontFamily: 'poppins' }}>
            Tag Color
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: matchessm ? 'row' : '',
              flexWrap: matchessm ? 'wrap' : '',
              alignItems: 'center',
              gap: '5px',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              {!wheelFlag &&
                colorCode.map((item, index) => (
                  <Box
                    sx={{
                      padding: '3px',
                      border: `3px solid ${
                        index == colorIndex ? item : 'white'
                      }`,
                      borderRadius: '50px',
                      '&:hover': {
                        border: `3px solid ${item}`,
                      },
                    }}
                  >
                    <Box
                      component={'div'}
                      onClick={() => colorSelect(item, index)}
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: matchessm ? '20px' : '25px',
                        height: matchessm ? '20px' : '25px',
                        borderRadius: '50px',
                        background: item,
                        cursor: 'pointer',
                      }}
                    >
                      {index == colorIndex && (
                        <Tick
                          width={matchessm ? 12 : 17}
                          height={matchessm ? 10 : 12}
                        />
                      )}
                    </Box>
                  </Box>
                ))}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: matchessm ? '20px' : '25px',
                  height: matchessm ? '20px' : '25px',
                  borderRadius: '50px',
                  background: hex,
                }}
              >
                {/* {colorIndex == null && <Tick width={ matchessm ? 12 : 17 } height={matchessm ? 10 : 12}/>} */}
              </Box>
            </Box>
            {!wheelFlag && (
              <Box
                sx={{ cursor: 'pointer' }}
                component="div"
                onClick={() => {
                  setWheelFlag(true);
                }}
              >
                <Multi sx={{ width: '25px', height: '25px' }} />
              </Box>
            )}
            {wheelFlag && (
              <Sketch
                color={hex}
                onChange={(color) => {
                  setHex(color.hex);
                }}
                onMouseLeave={() => {
                  setWheelFlag(false);
                }}
              />
            )}
            <Box>
              <Button
                color="primary"
                // onClick={addTagsFunc}
                onClick={addNewTags}
                sx={{
                  fontSize: '14px',
                  fontFamily: 'Poppins',
                  fontWeight: '400',
                  textTransform: 'none',
                  border: 'none !important',
                }}
              >
                + Add
              </Button>
            </Box>
          </Box>
          {storeTag != '' && (
            <Typography
              sx={{ fontSize: '12px', fontFamily: 'poppins', color: 'red' }}
            >
              {storeTag}
            </Typography>
          )}
          {editTagVal != '' && (
            <Typography
              sx={{ fontSize: '12px', fontFamily: 'poppins', color: 'red' }}
            >
              {editTagVal}
            </Typography>
          )}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '10px',
              flexWrap: 'wrap',
              margin: '10px 0',
            }}
          >
            {addTagsArr.map((item) => (
              <Button
                variant="outlined"
                sx={{
                  position: 'relative',
                  borderRadius: '20px',
                  padding: '8px 20px',
                  color: '#F93939',
                  fontSize: '12px',
                  fontFamily: 'Poppins',
                  fontWeight: '400',
                  textTransform: 'none',
                  border: 'none !important',
                  backgroundColor: item.tagColor,
                  textTransform: 'capitalize',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: item.tagColor,
                  },
                }}
              >
                <HighlightOff
                  onClick={() => removeTag(item.tagName)}
                  sx={{
                    position: 'absolute',
                    zIndex: 9999,
                    right: '-5px',
                    top: '-5px',
                    backgroundColor: '#ffff',
                    borderRadius: '50%',
                    color: 'grey',
                  }}
                />
                {item?.tagName}
              </Button>
            ))}
          </Box>
        </>
      )}

      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '20px',
          borderTop: '1px solid #ECE8E8',
          padding: '15px 0px',
        }}
      >
        {!editTags ? (
          <Button
            onClick={() => {
              setEditTags(true);
              setAddTags(false);
            }}
            color="primary"
            sx={{
              // borderRadius: "20px",
              // padding: "8px 20px",
              // color: "#F39800",
              fontSize: '14px',
              fontFamily: 'Poppins',
              fontWeight: '400',
              textTransform: 'none',
              border: 'none !important',
              // backgroundColor: "rgba(243, 152, 0, 0.25)",
            }}
          >
            Edit Tags
          </Button>
        ) : (
          <Button
            onClick={() => cancelFunc()}
            variant="outlined"
            color="primary"
            sx={{
              // borderRadius: "20px",
              padding: '10px 39px',
              color: '#666',
              fontSize: '14px',
              fontFamily: 'Poppins',
              fontWeight: '400',
              textTransform: 'none',
              border: '1px solid lightgrey',
            }}
          >
            Cancel
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          disabled={!isSaveEnabled()}
          onClick={() => {
            handleClickPost();
          }}
          sx={{
            // borderRadius: "20px",
            padding: '10px 39px',
            color: '#FFFFFF',
            fontSize: '14px',
            fontFamily: 'Poppins',
            fontWeight: '400',
            textTransform: 'none',
            border: 'none !important',
            backgroundColor: '#4CA4D6',
          }}
        >
          {isLoader ? (
            <CircularProgress
              size="small"
              sx={{ color: 'white', height: '25px', width: '25px' }}
            />
          ) : (
            'Save'
          )}
        </Button>
      </Grid>
    </Grid>
  );
};
